<div [ngClass]="{'import-block__completed': !isActive() && stepState == ImportStepState.Completed, 'import-block__collapsed': !isActive() && stepState == ImportStepState.Available, 'import-block__not-available': stepState <= ImportStepState.NotAvailableYet, 'loading': dataLoading }"
    class="import-block">
    <div class="d-flex align-items-center">
        <div class="number-circle"><span [ngClass]="{'subtitle-2': stepState !== ImportStepState.Completed, 'material-icons-outlined': (stepState === ImportStepState.Completed && !isActive())}">{{
                (stepState === ImportStepState.Completed && !isActive()) ? 'check' : '8' }}</span></div>
        <h4>Relative impact</h4>
    </div>
    <ng-container *ngIf="isActive()">
        <div>
            <div class="body-1 mb-8">Select the denominator to evaluate the relative impact of {{newControlValue}} - {{oldControlValue}} {{outcomeName}} variance</div>
            <div #tableContainer class="table-container column-border table-big">
                <!-- Header row -->
                <div class="row header">
                    <div *ngFor="let col of columns" class="cell" (click)="selectColumn(col)" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <div class="subtitle-2">{{col.name}}</div>
                        <span class="body-2">{{ displayRoughNum(col.uniqueValues) }}</span>
                    </div>
                </div>

                <!-- Data rows -->
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length">
                            {{col.someVals[0]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 1">
                            {{col.someVals[1]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 2">
                            {{col.someVals[2]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 3">
                            {{col.someVals[3]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 4">
                            {{col.someVals[4]}}
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="body-1 mb-16">Select how to calculate the {{selectedColumn.name}} denominator</div>
            <div class="radio-group separate-blocks">
                <label>
                    <input type="radio" name="basis" [value]="RefVolumeBasis.OldColumnValue" [(ngModel)]="basis">
                    <div class="radio-option">
                        <div class="radio-circle"></div>
                        <div class="radio-content">
                            <span class="subtitle-1" style="margin-bottom: 0px;">{{oldControlValue}} {{selectedColumn.name}}</span>
                            <span class="body-3" style="margin-bottom: 12px;">Default, best for stable {{selectedColumn.name}} across clusters</span>
                            <span class="body-2">Example: if {{oldControlValue}} {{selectedColumn.name}} = 1 and {{outcomeName}} variance = 10, the relative variance = 10 / 1 = 1000%.</span>
                        </div>
                    </div>
                </label>
                <label>
                    <input type="radio" name="basis" [value]="RefVolumeBasis.AverageColumnValue" [(ngModel)]="basis">
                    <div class="radio-option">
                        <div class="radio-circle"></div>
                        <div class="radio-content">
                            <span class="subtitle-1" style="margin-bottom: 0px;">Average of {{oldControlValue}} & {{newControlValue}} {{selectedColumn.name}}</span>
                            <span class="body-3" style="margin-bottom: 12px;">Use it for unstable {{selectedColumn.name}} across selected clusters.</span>
                            <span class="body-2">Example: if {{newControlValue}} {{selectedColumn.name}} = 9, using the average gives a smoother relative variance = 10 / ((9 + 1)/2) = 200%.</span>
                        </div>
                    </div>
                </label>
            </div>
        </div>
        <div>
            <label for="maxPerc" class="d-flex body-1 mb-8">If the denominator is zero or tiny, cap the relative impact at this percentage value</label>
            <div class="input-block mb-8">
                <div style="position: relative; display: inline-flex; align-items: center; width: 100%;">
                    <input class="text-field" [(ngModel)]="maxPerc" id="maxPerc" type="number" min="100" max="99999" step="1" style="padding-right: 28px;">
                    <span style="position: absolute; right: 12px; pointer-events: none;">%</span>
                </div>
            </div>
        </div>
        <div>
            <button (click)="save()" [ngClass]="{'loading-small':loading, 'btn':true}">Continue</button>
        </div>
    </ng-container>
    <ng-container *ngIf="!isActive() && stepState == ImportStepState.Completed">
        <div *ngIf="dataLoaded" class="d-flex">
            <div class="info-block">
                <span class="body-1">Denominator</span>
                <span class="body-1 text-900">{{selectedColumn.name}}{{(basis == RefVolumeBasis.OldColumnValue ? ', ' + oldControlValue : ' (avg)')}}</span>
            </div>
            <div class="info-block">
                <span class="body-1">Ceiling</span>
                <span class="body-1 text-900">{{maxPerc}}%</span>
            </div>
        </div>
        <div>
            <button (click)="editClick()" class="btn btn-secondary btn-icon btn-edit"><span class="material-icons-outlined">edit</span></button>
        </div>
    </ng-container>
</div>
